import React from 'react';
import { Link } from '@/components/LocaleLink';
import { useLanguage } from '@/contexts/language/LanguageContext';
import { footerCopy } from '@/contexts/language/translations/pages/footer';

const Footer = () => {
  const { language } = useLanguage();
  const c = footerCopy[language];
  return (
    <footer className="bg-white pt-16 pb-10">
      <div className="container-custom max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-12">
          {/* Left Section - Company Info */}
          <div className="flex-shrink-0">
            <Link 
              to="/" 
              className="hover:opacity-90 transition-opacity block mb-4"
            >
              <div className="flex items-center gap-2 mb-4">
                <img 
                  src="/lovable-uploads/Logo.png" 
                  alt={c.logoAlt} 
                  className="h-10 w-auto object-contain"
                />
              </div>
            </Link>
            <p className="text-sm text-muted-foreground">
              {c.tagline}
            </p>
          </div>
          
          {/* Right Section - Contact us, About */}
          {/* Same fixed width as the Privacy Policy link below, so both start at the same left edge */}
          <div className="md:w-32">
            <ul className="space-y-3">
              <li>
                <Link
                  to="/tell-me-more"
                  className="text-sm font-normal text-muted-foreground hover:text-foreground transition-colors"
                >
                  {c.contactUs}
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className="text-sm font-normal text-muted-foreground hover:text-foreground transition-colors"
                >
                  {c.about}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Section - Copyright on Left, Privacy on Right */}
        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              {c.copyright}
            </p>
            <div className="md:w-32 flex space-x-6 text-sm text-muted-foreground">
              <Link to="/privacy" className="hover:text-foreground transition-colors">{c.privacyPolicy}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
